<template>
  <div class="wrapper" id='printBody'>
    <div class="header">{{billTitle}}</div>
    <div class="basicInfo">
      <div class="inputItem">
        <span class="label">订货方：</span>
        <Input
          name="name"
          style="width: 300px"
          placeholder="请输入名称"
          v-model="basicInfo.customerName"
          @change="basicInfoChange"
        />
      </div>
      <div class="inputItem">
        <span class="label">电话：</span>
        <Input
          name="phone"
          style="width: 300px"
          placeholder="请输入电话"
          v-model="basicInfo.phone"
          @change="basicInfoChange"
        />
      </div>
      <div class="inputItem">
        <span class="label">地址：</span>
        <Input
          name="address"
          style="width: 300px"
          placeholder="请输入地址"
          v-model="basicInfo.address"
          @change="basicInfoChange"
        />
      </div>
      <div class="inputItem">
        <span class="label">备注：</span>
        <Input
          name="remark"
          style="width: 300px"
          placeholder="请输入备注"
          v-model="basicInfo.remark"
          @change="basicInfoChange"
        />
      </div>
    </div>
    <div class="operationsArea">
      <div class="operations">
        <Button class="editable-add-btn printHidden" @click="handleAdd">
          添加行
        </Button>
        <Button class="editable-add-btn" @click="toggleSelectAll">
          {{selectedRowKeys == 0 ? '商品全选' : '取消全选'}}
        </Button>
        <Button
          type="danger"
          :disabled="selectedRowKeys.length === 0"
          @click="deleteObjects"
        >删除</Button>
      </div>
      <div class="shopcarSubmitBtn">
        <span>合计金额：￥{{ totalPrice }}</span>
        <Button type="primary" @click="handleSave">提交订单</Button>
      </div>
      
      <!-- <div class="operBtn" @click='openPrint'>
        <i class="iconfont">&#xe877;</i>
        <span>打印</span>
      </div> -->
      <!-- <div class="operBtn"  @click='exportExcel'>
        <i class="iconfont">&#xe668;</i>
        <span>导出Excel</span>
      </div> -->
    </div>
    <div class="commoditiesArea">
      <div class="billList" v-if="plankList.length !== 0">
        <div class="billTitle">板材商品</div>
        <Table
          bordered
          :data-source="plankList"
          :columns="plankColumns"
          :pagination="false"
          :rowKey="getRowKey"
          :row-selection="rowSelection"
        >
          <template slot="count" slot-scope="text, record, index">
            <editable-cell
              inputType="number"
              :search="false"
              :editPermission="true"
              :text="text"
              @change="onCellChange(record, 'count', $event)"
              :width="70"
            />
          </template>
          <!-- <template slot="operationDesc" slot-scope="text, record, index">
            <editable-cell :search="false" :editPermission="true" :text="text" @change="onCellChange(record, 'operationDesc', $event)" />
          </template> -->
          <template slot="order" slot-scope="text, record, index">
            <span>{{index + 1}}</span>
          </template>
        </Table>
      </div>
      <div class="billList" v-if="hardwareList.length !== 0">
        <div class="billTitle">五金商品</div>
        <Table
          bordered
          :data-source="hardwareList"
          :columns="hardwareColumns"
          :pagination="false"
          :rowKey="getRowKey"
          :row-selection="rowSelection"
        >
          <template slot="count" slot-scope="text, record">
            <editable-cell
              inputType="number"
              :search="false"
              :editPermission="true"
              :text="text"
              @change="onCellChange(record, 'count', $event)"
              :width="70"
            />
          </template>
          <!-- <template slot="operationDesc" slot-scope="text, record, index">
            <editable-cell :search="false" :editPermission="true" :text="text" @change="onCellChange(record, 'operationDesc', $event)" />
          </template> -->
          <template slot="order" slot-scope="text, record, index">
            <span>{{index + 1}}</span>
          </template>
        </Table>
      </div>
      <div class="billList" v-if="edgeList.length !== 0">
        <div class="billTitle">封边商品</div>
        <Table
          bordered
          :data-source="edgeList"
          :columns="edgeColumns"
          :pagination="false"
          :rowKey="getRowKey"
          :row-selection="rowSelection"
        >
          <template slot="count" slot-scope="text, record, index">
            <editable-cell
              inputType="number"
              :search="false"
              :editPermission="true"
              :text="text"
              @change="onCellChange(record, 'count', $event)"
              :width="70"
            />
          </template>
          <!-- <template slot="operationDesc" slot-scope="text, record, index">
            <editable-cell :search="false" :editPermission="true" :text="text" @change="onCellChange(record, 'operationDesc', $event)" />
          </template> -->
          <template slot="order" slot-scope="text, record, index">
            <span>{{index + 1}}</span>
          </template>
        </Table>
      </div>
      <div class="billList" v-if="doorList.length !== 0">
        <div class="billTitle">门配商品</div>
        <Table
          bordered
          :data-source="doorList"
          :columns="doorColumns"
          :pagination="false"
          :rowKey="getRowKey"
          :row-selection="rowSelection"
        >
          <template slot="count" slot-scope="text, record, index">
            <editable-cell
              inputType="number"
              :search="false"
              :editPermission="true"
              :text="text"
              @change="onCellChange(record, 'count', $event)"
              :width="70"
            />
          </template>
          <!-- <template slot="operationDesc" slot-scope="text, record, index">
            <editable-cell :search="false" :editPermission="true" :text="text" @change="onCellChange(record, 'operationDesc', $event)" />
          </template> -->
          <template slot="order" slot-scope="text, record, index">
            <span>{{index + 1}}</span>
          </template>
        </Table>
      </div>
      <div class="billList" v-if="otherList.length !== 0">
        <div class="billTitle">设备商品</div>
        <Table
          bordered
          :data-source="otherList"
          :columns="otherColumns"
          :pagination="false"
          :rowKey="getRowKey"
          :row-selection="rowSelection"
        >
          <template slot="count" slot-scope="text, record, index">
            <editable-cell
              inputType="number"
              :search="false"
              :editPermission="true"
              :text="text"
              @change="onCellChange(record, 'count', $event)"
              :width="70"
            />
          </template>
          <!-- <template slot="operationDesc" slot-scope="text, record, index">
            <editable-cell :search="false" :editPermission="true" :text="text" @change="onCellChange(record, 'operationDesc', $event)" />
          </template> -->
          <template slot="order" slot-scope="text, record, index">
            <span>{{index + 1}}</span>
          </template>
        </Table>
      </div>
      <div class="billList" v-if="modelList.length !== 0">
        <div class="billTitle">模型商品</div>
        <Table
          bordered
          :data-source="modelList"
          :columns="modelColumns"
          :pagination="false"
          :rowKey="getRowKey"
          :row-selection="rowSelection"
          >
          <template slot="count" slot-scope="text, record">
            <editable-cell
              inputType="number"
              :search="false"
              :editPermission="true"
              :text="text"
              @change="onCellChange(record, 'count', $event)"
              :width="70"
            />
          </template>
          <template slot="order" slot-scope="text, record, index">
            <span>{{index + 1}}</span>
          </template>
        </Table>
      </div>
    </div>
    <ProductSelector
      @close="closeAdd"
      v-if="showAdd"
      @confirm="addItems"
      :supplierInfo="supplierInfo"
    />
  </div>
</template>

<script>
// const XLSX = require('xlsx');
import { Table, Input, Button } from 'ant-design-vue';
import Vue from 'vue';
// import 'ant-design-vue/dist/antd.css';
import 'ant-design-vue/es/button/style/css';
import 'ant-design-vue/es/input/style/css';
import 'ant-design-vue/es/table/style/css';
import '../../util/default.css'
import EditableCell from '../../components/cloud/EditableCell.vue';
import ProductSelector from '../../components/cloud/ProductSelectorForShopcar.vue';
import { mapMutations, mapState } from 'vuex';

// import {
//   getBill, getObjectList, saveBill,
//   getSupplierInfo, submitOrder
// } from '../../util/requests';
import { getModifiedBillPayload, shopCarInfoNormalize } from '../../util/processingData';

const searchingKeys = ['name', 'color', 'type', 'thick'];

export default {
  components: {
    EditableCell, Table, Input, Button, ProductSelector
  },
  computed: {
    ...mapState([
      'userInfo', 'shopCarInfo'
    ]),
    plankList() {
      return this.dataSource.filter((item) => {
        return item.part_type == 'plank'
      })
    },
    edgeList() {
      return this.dataSource.filter((item) => {
        return item.part_type == 'edge'
      })
    },
    hardwareList() {
      return this.dataSource.filter((item) => {
        return item.part_type == 'hardware'
      })
    },
    doorList() {
      return this.dataSource.filter((item) => {
        return item.part_type == 'door'
      })
    },
    otherList() {
      return this.dataSource.filter((item) => {
        return item.part_type == 'other'
      })
    },
    modelList() {
      return this.dataSource.filter(item => item.part_type == 'model')
    },
    totalPrice() {
      let result = 0;
      const chosedRows = this.dataSource.filter((data, index) => {
        return this.selectedRowKeys.indexOf(data.id) !== -1;
      });
      chosedRows.forEach((item) => {
        if (Number(item.totalPrice)) {
          result += Number(item.totalPrice);
        }
      })
      return Number(result.toFixed(2));
    },
    pageType() {
      return this.$route.params.pageType;
    },
    billId() {
      return this.$route.params.billId;
    },
    nameChangePermission() {
      return this.$route.params.billId ? false : true;
    },
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys) => {
          this.selectedRowKeys = selectedRowKeys;
        }
      }
    },
    billTitle(){
      // {{supplierInfo.name}}{{pageType == 'import' ? '入' : '出'}}库单
      return `购物车（供应商：${this.supplierInfo && this.supplierInfo.name || ''}）`;
    }
  },
  data() {
    return {
      showAdd: false,
      dataSource: [{
        name: ''
      }],
      supplierInfo: {},
      customerName: '',
      address: '',
      phone: '',
      onPrint:false,//打印时隐藏不必要的部分
      originalData: [],
      objectSelectionsCount: 0, // 全部商品列表的总数，用于内部表格的分页
      objectSelections: [], // 商品选择弹框商品列表数据
      selectedRowKeys: [],
      basicInfo: {
        customerName: '',
        address: '',
        phone: '',
        remark: ''
      },
      plankColumns: [
        {
          title: '序号',
          align: 'center',
          scopedSlots: { customRender: 'order' },
          width: 80
        },
        {
          title: '基材',
          dataIndex: 'type',
        },
        {
          title: '颜色',
          dataIndex: 'color',
        },
        {
          title: '厚度mm',
          dataIndex: 'thick',
        },
        {
          title: '名称',
          dataIndex: 'name',
        },
        {
          title: '钢板纹理',
          dataIndex: 'texture',
        },
        {
          title: '数量',
          dataIndex: 'count',
          scopedSlots: { customRender: 'count' },
          width: 110,
        },
        {
          title: '单价',
          dataIndex: this.$store.state.userInfo.cloud_vip?'price':'ret_price'
        }, {
          title: '金额',
          dataIndex: 'totalPrice'
        },
        {
          title: '贴面工艺',
          dataIndex: 'texture_method',
        },
        {
          title: '品牌',
          dataIndex: 'brand',
        },
        {
          title: '备注',
          dataIndex: 'remark',
        }
      ],
      hardwareColumns: [
        {
          title: '序号',
          align: 'center',
          scopedSlots: { customRender: 'order' },
          width: 80
        },
        {
          title: '名称',
          dataIndex: 'name',
        },
        {
          title: '分类',
          dataIndex: 'brand_type',
        },
        {
          title: '五金颜色',
          dataIndex: 'color',
        },
        {
          title: '材质',
          dataIndex: 'material',
        },
        {
          title: '数量',
          dataIndex: 'count',
          scopedSlots: { customRender: 'count' },
          width: 110,
        },
        {
          title: '单价',
          dataIndex: this.$store.state.userInfo.cloud_vip?'price':'ret_price'
        }, {
          title: '金额',
          dataIndex: 'totalPrice'
        },
        {
          title: '规格',
          dataIndex: 'spec',
        },
        {
          title: '品牌',
          dataIndex: 'brand',
        },
        {
          title: '备注',
          dataIndex: 'remark',
        }
      ],
      edgeColumns: [
        {
          title: '序号',
          align: 'center',
          scopedSlots: { customRender: 'order' },
          width: 80
        },
        {
          title: '名称',
          dataIndex: 'name',
        },
        {
          title: '封边颜色',
          dataIndex: 'color',
        },
        {
          title: '材质',
          dataIndex: 'material',
        },
        {
          title: '厚度mm',
          dataIndex: 'thick',
        },
        {
          title: '宽度mm',
          dataIndex: 'width',
        },
        {
          title: '规格',
          dataIndex: 'spec',
        },
        {
          title: '数量',
          dataIndex: 'count',
          scopedSlots: { customRender: 'count' },
          width: 110,
        },
        {
          title: '单价',
          dataIndex: this.$store.state.userInfo.cloud_vip?'price':'ret_price'
        }, {
          title: '金额',
          dataIndex: 'totalPrice'
        },
        {
          title: '品牌',
          dataIndex: 'brand',
        },
        {
          title: '备注',
          dataIndex: 'remark',
        }
      ],
      doorColumns: [
        {
          title: '序号',
          align: 'center',
          scopedSlots: { customRender: 'order' },
          width: 80
        },
        {
          title: '名称',
          dataIndex: 'name',
        },
        {
          title: '分类',
          dataIndex: 'brand_type',
        },
        {
          title: '门配颜色',
          dataIndex: 'color',
        },
        {
          title: '材质',
          dataIndex: 'material',
        },
        {
          title: '厚度mm',
          dataIndex: 'thick',
        },
        {
          title: '规格',
          dataIndex: 'spec'
        },
        {
          title: '数量',
          dataIndex: 'count',
          scopedSlots: { customRender: 'count' },
          width: 110,
        },
        {
          title: '单价',
          dataIndex: this.$store.state.userInfo.cloud_vip?'price':'ret_price'
        }, {
          title: '金额',
          dataIndex: 'totalPrice'
        },
        {
          title: '品牌',
          dataIndex: 'brand',
        },
        {
          title: '备注',
          dataIndex: 'remark',
        }
      ],
      otherColumns: [
        {
          title: '序号',
          align: 'center',
          scopedSlots: { customRender: 'order' },
          width: 80
        },
        {
          title: '名称',
          dataIndex: 'name',
        },
        {
          title: '分类',
          dataIndex: 'brand_type',
        },
        {
          title: '设备颜色',
          dataIndex: 'color',
        },
        {
          title: '材质',
          dataIndex: 'material',
        },
        {
          title: '规格',
          dataIndex: 'spec',
        },
        {
          title: '数量',
          dataIndex: 'count',
          scopedSlots: { customRender: 'count' },
          width: 110,
        },
        {
          title: '单价',
          dataIndex: this.$store.state.userInfo.cloud_vip?'price':'ret_price'
        }, {
          title: '金额',
          dataIndex: 'totalPrice'
        },
        {
          title: '品牌',
          dataIndex: 'brand',
        },
        {
          title: '备注',
          dataIndex: 'remark',
        }
      ],
      /** TODO: 完善模型列表显示 */
      modelColumns: [
        {
          title: '序号',
          align: 'center',
          scopedSlots: { customRender: 'order' },
          width: 80
        },
        {
          title: '名称',
          dataIndex: 'name',
        },
        {
          title: '数量',
          dataIndex: 'count',
          scopedSlots: { customRender: 'count' },
          width: 110,
        },
        {
          title: '单价',
          dataIndex: this.$store.state.userInfo.cloud_vip?'price':'ret_price'
        }, {
          title: '金额',
          dataIndex: 'totalPrice'
        },
      ],
    };
  },
  methods: {
    ...mapMutations([
      'setShopCar'
    ]),
    closeAdd() {
      this.showAdd = false;
    },
    addItems(items) {
      this.setShopCar({
        shopCarInfo: {
          uid: this.userInfo.id,
          supplierId: this.supplierInfo.id,
          items
        },
        mode: 'add'
      });
      this.closeAdd();
    },
    toggleSelectAll() {
      if (this.selectedRowKeys.length == 0) {
        this.selectedRowKeys = this.dataSource.map((item) => {
          return item.id;
        })
      } else {
        this.selectedRowKeys = [];
      }
      
    },
    basicInfoChange() {
      const { address, customerName, phone, remark } = this.basicInfo;
      this.setShopCar({
        shopCarInfo: {
          uid: this.userInfo.id,
          supplierId: this.$route.params.supplierId,
          items: this.dataSource,
          address,
          customerName,
          phone,
          remark
        },
        mode: 'update'
      });
    },
    handleSave() {
      const chosedRows = this.dataSource.filter((data, index) => {
        return this.selectedRowKeys.indexOf(data.id) !== -1;
      });
      const remainRows = this.dataSource.filter((data, index) => {
        return this.selectedRowKeys.indexOf(data.id) === -1;
      });
      if (chosedRows.length == 0) {
        this.$message('请至少选择一项商品提交订单');
        return;
      }

      if (chosedRows.find((item) => {
        // console.log('提交',item)
        return !item.id;
      })) {
        // 如果找到没有id的item，说明没有选择产品，不允许提交
        this.$message('不能在订单里提交不存在的商品');
        return;
      }
      
     /*  if(!JSON.parse(localStorage.getItem('data')).cloud_vip) {
        this.$confirm('您不是云仓会员，不能提交订单购买商品，是否前往开通?', '提示', {
          confirmButtonText: '去开通',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          window.location.href = './cloudProduct.html'
        }).catch(() => {});
        return;
      } */
      const { address, phone, customerName, remark } = this.basicInfo;
      if (!address || !phone || !customerName) {
        this.$message('收货方、地址、电话不能为空');
        return;
      }
      const payload = {
        address, phone_number: phone, name: customerName, remark,
        uid: this.userInfo.id,
        commodity_list: chosedRows.map((item) => {
          return {
            id: item.id,
            count: Number(item.count)
          }
        })
      }

      this.$requests.submitOrder(payload).then((res) => {
        console.log('submit order: ', res);
        /*  const {
            order_ids: orderId, vip_price: totalPrice,
            final_price: finalPrice, discount_price: discount
          } = res */
          console.log('vip',this.userInfo.cloud_vip)
          let orderId = res.order_ids
          let totalPrice =''
          if(this.$store.state.userInfo.cloud_vip){
            totalPrice = res.vip_price
          }else{
            totalPrice = res.total_price
          }
          
          let finalPrice = res.final_price
          let discount = res.discount_price
         /*  if(this.userInfo.cloud_vip == 0){
             totalPrice = res.total_price
          } */
        /* if(this.userInfo.cloud_vip == 0){
          const {
            order_ids: orderId, total_price: totalPrice,
            final_price: finalPrice, discount_price: discount
          } = res
        }else{
          const {
            order_ids: orderId, vip_price: totalPrice,
            final_price: finalPrice, discount_price: discount
          } = res
        } */
        // 提交成功后，清除选择, 并更新购物车
        this.selectedRowKeys = [];
        this.setShopCar({
          shopCarInfo: {
            uid: this.userInfo.id,
            supplierId: this.supplierInfo.id,
            items: remainRows,
          },
          mode: 'update'
        });
        this.$router.push({
          name: 'OrderPayment',
          query: {
            info: JSON.stringify({
              basicInfo: this.basicInfo,
              dataSource: chosedRows,
              supplierInfo: this.supplierInfo,
              totalPrice,
              discount,
              finalPrice,
              orderId: orderId[0]
            })
          }
        })
      }, () => {
        this.$message('提交订单失败，请重试');
      })
    },
    // updateObjectList(page, key, value) {
    //   const keyValue = {};
    //   const keys = searchingKeys.filter((item) => {
    //     return item !== key;
    //   })
    //   keys.forEach((item) =>{
    //     keyValue[item] = this.dataSource[this.targetObjectIndex][item];
    //   });
    //   keyValue[key] = value;
    //   getObjectList(this.supplierInfo.id, keyValue, page, 1).then((res) => {
    //     if (res) {
    //       this.objectSelections = res.list;
    //       this.objectSelectionsCount = res.count;
    //     }
    //   })
    // },
    choseItem(record) {
      this.setShopCar({
        shopCarInfo: {
          uid: this.userInfo.id,
          supplierId: this.$route.params.supplierId,
          items: [record]
        },
        mode: 'add'
      });
    },
    deleteObjects() {
      this.dataSource = this.dataSource.filter((data, index) => {
        return this.selectedRowKeys.indexOf(data.id) === -1;
      });
      this.selectedRowKeys = [];
      console.log(this.dataSource)
      this.setShopCar({
        shopCarInfo: {
          items: this.dataSource,
          uid: this.userInfo.id,
          supplierId: this.$route.params.supplierId
        },
        mode: 'update'
      })
    },
    getRowKey(record, index) {
      return record.id; // 用商品id作为表格的rowkey，复选的选项则存到统一的selectedRowKeys中
    },
    onCellChange(record, dataIndex, value) {
      // this.targetObjectIndex = index;  // 记录当前正在编辑的行，以便用户选择对应商品后能更新数据dataSource
      // if (searchingKeys.find((item) => { return item == dataIndex })) {
      //   // 当正在编辑搜索功能字段时，去请求对应商品列表，商品列表通过属性的形式传给商品选择组件
      //   // 不修改dataSource中对应值
      //   this.updateObjectList(1, dataIndex, value);
      //   return;
      // }
      record[dataIndex] = value;
      this.setShopCar({
        shopCarInfo: {
          uid: this.userInfo.id,
          supplierId: this.$route.params.supplierId,
          items: this.dataSource
        },
        mode: 'update'
      })
      // const dataSource = [...this.dataSource];
      // const target = dataSource[index];
      // if (target) {
      //   target[dataIndex] = value;
      //   this.setShopCar({
      //     shopCarInfo: {
      //       uid: this.userInfo.id,
      //       supplierId: this.$route.params.supplierId,
      //       items: dataSource
      //     },
      //     mode: 'update'
      //   })
      // }
    },
    onDelete(key) {
      const dataSource = [...this.dataSource];
      this.dataSource = dataSource.filter(item => item.key !== key);
    },
    handleAdd() {
      this.showAdd = true;
      // 打开商品选择框
      // const { dataSource } = this;
      // const newData = {
      //   name: '', // 设置name为空字符串是为了点击该单元格能以空字符串为关键词搜索商品列表
      // };
      // this.dataSource = [...dataSource, newData];
    },
    // 保存单据
    saveStorage(){
      let supplierInfo = this.supplierInfo;
      let JsonData = {
        supplier_id:supplierInfo.id,
        supplier_name:supplierInfo.name,
        order_type:this.pageType == 'import'?'1':'2',
        detail:'',
        data:[]
      }
      this.dataSource.forEach(item => {
        let oldCount = item.count
        let data = {
          commodity_type:"plank",
          plank_id:item.id,
          num:item.count
        }
      })
    },
    exportExcel(){
          var filename =this.billTitle+Math.round(new Date() / 1000)+ ".xlsx"; //文件名称
          var data=[
            [this.billTitle,null,null,null,null,null,null,null,null,null,null,null],
            [`客户:${this.basicInfo.name}`,null,null,null,`出库单号:${this.basicInfo.billNum}`,null,null,null,`备注:${this.basicInfo.remark}`,null,null,null],
            ['序号','板材名称','板材颜色','基材','厚度','钢板纹理','数量','贴面工艺','品牌','备注','出库说明',null]
          ]
          // console.log(this.dataSource)
          for(let i=0,len=this.dataSource.length;i<len;i++){
            let row=this.dataSource[i]
            data.push([
              i+1,
              row.name||'',
              row.color||'',
              row.type||'',
              row.thick||'',
              row.texture||'',
              row.count||'',
              row.texture_method||'',
              row.brand||'',
              row.remark||'',
              row.operationDesc||'',
              null
            ])
          }
          // console.log(data)
          var ws_name = "Sheet1"; //Excel第一个sheet的名称
          var wb = XLSX.utils.book_new()
          var ws = XLSX.utils.aoa_to_sheet(data);

          let merge= [
              {s: {r: 0, c: 0}, e: {r: 0, c: 11}},
              {s: {r: 1, c: 0}, e: {r: 1, c: 3}},
              {s: {r: 1, c: 4}, e: {r: 1, c: 7}},
              {s: {r: 1, c: 8}, e: {r: 1, c: 11}},
              {s: {r: 2, c: 10}, e: {r: 2, c: 11}}
          ];
          for(let i=0,len=this.dataSource.length;i<len;i++){
            merge.push({s: {r: i+3, c: 10}, e: {r: i+3, c: 11}})
          }
          ws['!merges'] =merge
          // ws["A3"].s = {									//为某个单元格设置单独样式
          //   font: {
          //     name: '宋体',
          //     sz: 24,
          //     bold: true,
          //     color: { rgb: "FFFFAA00" }
          //   },
          //   alignment: { horizontal: "center", vertical: "center", wrap_text: true },
          //   fill: { bgcolor: { rgb: 'ffff00' } }
          // }
          ws['!cols'] = [{
              wch: 20
            },{
              wch: 20
            },{
              wch: 20
            },{
              wch: 20
            },{
              wch: 20
            },{
              wch: 20
            },{
              wch: 20
            },{
              wch: 20
            },{
              wch: 20
            },{
              wch: 20
            },{
              wch: 20
            },{
              wch: 20
            }
          ];
          // ws['!rows'] = [{
          //     hpx: 25,
          //   },
          //   {
          //       hpx: 15,
          //   },
          // ]
          XLSX.utils.book_append_sheet(wb, ws, ws_name);  //将数据添加到工作薄
          XLSX.writeFile(wb, filename); //导出Excel

    },
    openPrint() {
      let that=this
      var userAgent = navigator.userAgent.toLowerCase(); //取得浏览器的userAgent字符串
      if (userAgent.indexOf("trident") > -1) {
        alert("请使用google或者360浏览器打印");
        return false;
      } else if (userAgent.indexOf('msie') > -1) {
        var onlyChoseAlert = simpleAlert({
          "content" : "请使用Google或者360浏览器打印",
          "buttons" : {
            "确定" : function() {
              onlyChoseAlert.close();
            }
          }
        })
        alert("请使用google或者360浏览器打印");
        return false;
      } else {//其它浏览器使用lodop
        var head=window.document.head.innerHTML;
        let headTemp=head.split(`<meta http-equiv="Content-Security-Policy" content="upgrade-insecure-requests">`)
        head=''
        // console.log(headTemp)
        for(let item of headTemp){
          head+=item
        }
        // console.log(head)

        head=head.replace(`<link href="./`,`<link href="https://www.guigui.com.cn/`)

        var headstr = "<html><head>"+head+"</head><body>";
        // console.log(headstr)
        // return
        var footstr = '</body></html>'
        //执行隐藏打印区域不需要打印的内容
        let printHidden=document.getElementsByClassName("printHidden")
        let displayOld=[]
        for (let item of printHidden) {
              let oldDisplay=item.style.display
              if(oldDisplay==""){
                oldDisplay=window.getComputedStyle(item,null)['display']
                if(oldDisplay==""){
                  oldDisplay="block"
                }
              }
              displayOld.push(oldDisplay)
              item.style.display="none";
        }
        // console.log(displayOld)
         // that.onPrint=true
        var printData = document.getElementById("printBody").innerHTML; //获得 div 里的所有 html 数据
        var wind = window.open("", "newwin","toolbar=no,scrollbars=yes,menubar=no");
        wind.document.write(headstr + printData + footstr)
        wind.document.write("<script>window.print()</\script>")
        // console.log(wind)
        // wind.onload=function(){
        //     wind.print();
        // }






        //打印结束后，放开隐藏内容

        for (let i=0,len=printHidden.length;i<len;i++) {
              let item=printHidden[i]
              item.style.display=displayOld[i];
        }
        // that.onPrint=false
        // wind.close();
      }
    }
  },
  watch: {
    shopCarInfo(value) {
      // 获取当前购物车数据
      const shopCar = value[this.userInfo.id] && value[this.userInfo.id][this.$route.params.supplierId];
      if (shopCar) {
        const { items, address, customerName, remark, phone } = shopCar;
        this.basicInfo = {
          address, customerName, remark, phone
        };
        this.dataSource = items;
      }
    },
  },
  created() {
    const supplierId = this.$route.params.supplierId;
    if (this.$route.params.supplierId) {
      this.$requests.getSupplierInfo({
        id: supplierId
      }).then((res) => {
        this.supplierInfo = res;
      });
    }

    // 获取默认用户信息
    const { name, phone, address } = this.userInfo;
    this.basicInfo = {
      customerName: name,
      address,
      phone
    }

    // 获取当前购物车数据
    const shopCar = this.shopCarInfo[this.userInfo.id] && this.shopCarInfo[this.userInfo.id][this.$route.params.supplierId];
    if (shopCar) {
      const { items, address, customerName, remark, phone } = shopCar;
      this.basicInfo = {
        address, customerName, remark, phone
      };
      this.dataSource = items;
      console.log('====items======')
      console.log(items)
    }
  }
};
</script>

<style scoped>
@font-face {
  font-family: 'iconfont';  /* project id 1805586 */
  src: url('//at.alicdn.com/t/font_1805586_kpnnhtv7v6s.eot');
  src: url('//at.alicdn.com/t/font_1805586_kpnnhtv7v6s.eot?#iefix') format('embedded-opentype'),
  url('//at.alicdn.com/t/font_1805586_kpnnhtv7v6s.woff2') format('woff2'),
  url('//at.alicdn.com/t/font_1805586_kpnnhtv7v6s.woff') format('woff'),
  url('//at.alicdn.com/t/font_1805586_kpnnhtv7v6s.ttf') format('truetype'),
  url('//at.alicdn.com/t/font_1805586_kpnnhtv7v6s.svg#iconfont') format('svg');
}
.iconfont{
  font-family:"iconfont" !important;
  font-size:16px;font-style:normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}
.wrapper {
  width: 90%;
  margin: auto;
  min-width: 1200px;
  height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 60px 0;
}
.wrapper > div {
  flex-shrink: 0;
}
.wrapper > div.commoditiesArea {
  flex-shrink: 1;
  flex: 1;
  overflow: auto;
}

.header {
  margin-bottom: 30px;
  font-size: 30px;
}
.basicInfo, .operations {
  display: flex;
  margin-bottom: 20px;
  align-items: center;
}

.basicInfo {
  margin-bottom: 40px;
}

.basicInfo {
  justify-content: space-between;
}

.operations > div {
  cursor: pointer;
}

.operations > div:not(:last-child), .operations > button {
  margin-right: 40px;
}
.operations > button:first-child {
  margin-right: 20px;
}

.billList {
  margin-bottom: 20px;
}

.billList button {
  margin-top: 20px;
}
.shopcarSubmitBtn {
  text-align: left;
}
.shopcarSubmitBtn > span {
  display: inline-block;
  margin-right: 20px;
}
.operationsArea {
  display: flex;
  justify-content: space-between;
}

.billTitle {
  font-weight: bold;
  font-size: 18px;
}
</style>
